import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import ConsumerLayout from '@/components/ConsumerLayout';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <ConsumerLayout hideFooter>
      
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <Card data-testid="payment-cancel-card">
          <CardContent className="p-12 text-center">
            <XCircle className="w-16 h-16 text-orange-500 mx-auto mb-6" />
            <h1 className="text-3xl font-bold text-foreground mb-4">
              Payment Cancelled
            </h1>
            <p className="text-lg text-muted-foreground mb-8">
              Your payment was cancelled. No charges have been made to your account.
            </p>
            <div className="flex gap-4 justify-center">
              <Button
                onClick={() => navigate(-1)}
                className="bg-indigo-600 hover:bg-indigo-700"
                data-testid="try-again-btn"
              >
                Try Again
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate('/events')}
                data-testid="browse-events-btn"
              >
                Browse Events
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </ConsumerLayout>
  );
};

export default PaymentCancel;
